import SliderComponent from './views/Slider.c';
export default SliderComponent;
